
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';

@Component
export default class SearchCustomer extends Vue {
    @Getter customerList: any;
    @Prop() chooseCustomerVisible: boolean;
    @Prop() confirmSelectedCustomer: Function;
    @Action('getCustomerList') getCustomerList: Function;

    searchVal: string = '';
    selectedCustomer: {[key: string]: any} = {};

    // 关闭弹窗
    handleClose() {
        // 清空表格数据
        this.closeVisible();
    }

    setCurrent(row: number) {
        (this.$refs.singleTable as any).setCurrentRow(row);
    }

    handleCurrentChange(val: {[key: string]: any}) {
        this.selectedCustomer = val;
    }

    // 关闭窗口
    closeVisible() {
        this.searchVal = '';
        this.selectedCustomer = {};
        this.$emit('closeChooseCustomerVisible', true);
    }

    handleSelect(key: any) {
        this.searchVal = '';
        this.$emit('closeChooseCustomerVisible', true);
    }

    // 确认选择的条目
    confirmbtn() {
        this.confirmSelectedCustomer(this.selectedCustomer);
    }

    // 确认搜索
    onSubmit() {
        this.getCustomerList({keyword: this.searchVal, isPage: false, top: 100});
    }

}
